var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',{staticClass:"ta-lot-list-item-title font-weight-bold"},[_c('router-link',{attrs:{"to":_vm.lotInnerPageRoute},domProps:{"innerHTML":_vm._s(_vm.title)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }